/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArchivingContractPropertiesLogDTO } from './archiving-contract-properties-log-dto';
import { EmailNotificationDetailDTO } from './email-notification-detail-dto';
import { ContractStatusEnumDTO } from './contract-status-enum-dto';


export interface ArchivingContractDTO { 
    /**
     * System generated UID for the contract.
     */
    id?: string;
    /**
     * Customer name used for the contract.
     */
    customerName?: string;
    /**
     * The customer identifier from the billing system this tenant is linked to.
     */
    customerIdentifier?: string;
    contractPropertiesLog?: Array<ArchivingContractPropertiesLogDTO>;
    notifications?: Array<EmailNotificationDetailDTO>;
    status?: ContractStatusEnumDTO;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
}

export class ClsArchivingContractDTO { 
    /**
     * System generated UID for the contract.
     */
    id?: string = undefined;
    /**
     * Customer name used for the contract.
     */
    customerName?: string = undefined;
    /**
     * The customer identifier from the billing system this tenant is linked to.
     */
    customerIdentifier?: string = undefined;
    contractPropertiesLog?: Array<ArchivingContractPropertiesLogDTO> = undefined;
    notifications?: Array<EmailNotificationDetailDTO> = undefined;
    status?: ContractStatusEnumDTO = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
}



